import React, { useState } from 'react';
import { Layout, ProtectedRoute } from '../components/layout';
import { Button } from '../components/common';
import { GameList, CreateGameModal, JoinGameModal } from '../components/games';
import { useGames } from '../hooks/useGames';

export const Dashboard = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const { data, isLoading } = useGames();

  return (
    <ProtectedRoute>
      <Layout>
        <div className="max-w-4xl mx-auto px-4 py-8">
          {/* Games Header */}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-4 mb-6">
            <h1 className="text-2xl font-bold">Your Games</h1>
            <div className="flex gap-2">
              <Button variant="secondary" onClick={() => setShowJoinModal(true)}>
                Join By Code
              </Button>
              <Button onClick={() => setShowCreateModal(true)}>
                + New Game
              </Button>
            </div>
          </div>

          {/* Games List */}
          <GameList games={data?.games} loading={isLoading} />

          {/* Modals */}
          <CreateGameModal
            isOpen={showCreateModal}
            onClose={() => setShowCreateModal(false)}
          />
          <JoinGameModal
            isOpen={showJoinModal}
            onClose={() => setShowJoinModal(false)}
          />
        </div>
      </Layout>
    </ProtectedRoute>
  );
};
